




import { Vue, Component } from 'vue-property-decorator'
import { mapActions, mapGetters } from 'vuex'
import { APP_MODULE, FALLBACK_ROUTE, RESET_STATE, TRANSLATE } from '../../../store/modules/app/constant'
import { ResetStatePayload } from '../../../store/modules/app/types'

@Component({
  methods: {
    ...mapActions(APP_MODULE, [RESET_STATE])
  },
  computed: {
    ...mapGetters(APP_MODULE, [TRANSLATE])
  },
})
export default class BackButton extends Vue {
  back() {
    const challenge = this.$route?.query?.challenge as string
    const fallbackRoute = localStorage.getItem(FALLBACK_ROUTE) as string
    const payload: ResetStatePayload = {
      challenge: challenge,
      state: fallbackRoute
    }
    if (fallbackRoute != '') {
      (this as any)[RESET_STATE](payload)
        .then(() => {
          // do nothing
        })
        .catch((e: unknown) => {
          console.error(e)
        })
        .finally(() => {
          this.navigateBackRouteByFallback()
        })
    } else {
      history.back()
    }
  }
  navigateBackRouteByFallback() {
    const challenge = this.$route?.query?.challenge as string
    const email = this.$route?.query?.email as string
    const fallbackRoute = localStorage.getItem(FALLBACK_ROUTE) as string
    this.$router.push({ path: fallbackRoute, query: { challenge: challenge, email: email } }).catch(e => {
      console.error(e)
      history.back()
    })
  }
}
